import React from "react";
import TestCard from "../../pages/Dashboard/TestCard";
import Empty from "../../assets/assets/empty.svg";
import Product from "../../pages/Dashboard/Product";
import Expiry from "../Expiry/Expiry";
import ContinueCertification from "../Certification/ContinueCertification";
import { PropTypes } from "prop-types";

const CertInProgress = (props) => {
  const {
    application,
    companyId,
    goToSinglePage,
    status,
    results,
    resultsLength,
    getStatus,
    categoryChoice,
    testCardStatus,
    userType,
    pos,
    application_info,
    posLength,
    goToSinglePage2,
    expired
  } = props;

  const updatingStatus =
    status && status[0] && status[0].nibss_super_admin_status;
  const updatingStatus2 = status && status[0] && status[0].status;
  const cbnExpiryDate = status && status[0] && status[0].cbn_license_expired;
  const posId = pos && pos[0] && pos[0].id;
  const appType = status && status[0] && status[0].application_type;
  const tid = status && status[0] && status[0].tid;
  const portNo = status && status[0] && status[0].port_number;
  const trailUser =
    status && status[0] && status[0].trail && status[0].trail.user;
  const trailAdmin =
    status && status[0] && status[0].trail && status[0].trail.admin;
  const certifiedStatus =
    updatingStatus === "pending" || updatingStatus2 === "pending";
  const renewalCount = status && status[0] && status[0].renewal_count;

  return (
    updatingStatus === "certfication_requirements_in_progress" &&
    updatingStatus2 === "certfication_requirements_in_progress" && (
      <div>
        {!cbnExpiryDate && application_info && application_info.length === 0 ? (
          <div className="pos-doc-sec">
            <div className="empty2">
              <br />
              <br />
              <div>
                <img src={Empty} alt="empty2" />
              </div>
              <h1>No Products</h1>
              <p>
                There are no products recieved. Please continue your application
              </p>
              <br />
              <div>
                {posLength > 1 ? (
                  <div>
                    <div className="continue-sec">
                      <button
                        data-testid="continue-sec"
                        className="continue-sec-btn2"
                        onClick={() => goToSinglePage2()}
                      >
                       view pos dashboard
                      </button>
                    </div>
                  </div>
                ) : (
                  <div>
                    {appType === "pos_application_certification" && (
                      <ContinueCertification
                        appId={posId}
                        companyId={companyId}
                        user={trailUser}
                        admin={trailAdmin}
                        type={appType}
                        tid={tid}
                        renewalCount={renewalCount}
                        portNo={portNo}
                      />
                    )}
                    {appType === "pos_device_certification" && (
                      <ContinueCertification
                        appId={posId}
                        renewalCount={renewalCount}
                        companyId={companyId}
                        user={trailUser}
                        admin={trailAdmin}
                        type={appType}
                        tid={tid}
                        portNo={portNo}
                      />
                    )}
                  </div>
                )}
              </div>
            </div>

            <div className="testcard-main" style={{ marginTop: "0px" }}>
              <TestCard
                certifiedStatus={certifiedStatus}
                appId={posId}
                userType={userType}
                companyId={companyId}
                results={results}
                resultsLength={resultsLength}
                getUserStatus={getStatus}
                categoryChoice={categoryChoice}
                testCardStatus={testCardStatus}
                expired={expired}
              />
            </div>
          </div>
        ) : (
          <div className="docs-section">
            <h2>
              Based on your application you have access to the listed NIBSS
              product and services
            </h2>
            {application && application.expiry_date && (
              <Expiry
                days_left={application.days_left}
                expired={cbnExpiryDate}
                date={application.expiry_date}
              />
            )}
            <div className="pos-doc-sec">
              <div className="documentation">
                {application_info &&
                  application_info.map((doc) => (
                    <div className="overlay-holder" key={doc.id}>
                      <Product
                        docUrl={doc.url}
                        id={doc.id}
                        docName={doc.name}
                        goToSinglePage={goToSinglePage}
                        iconUrl={doc.image_url}
                        colorCode={doc.color_code}
                      />
                    </div>
                  ))}
              </div>

              <div className="testcard-main" style={{ marginTop: "0px" }}>
                <TestCard
                  certifiedStatus={certifiedStatus}
                  appId={posId}
                  userType={userType}
                  companyId={companyId}
                  results={results}
                  resultsLength={resultsLength}
                  getUserStatus={getStatus}
                  categoryChoice={categoryChoice}
                  testCardStatus={testCardStatus}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    )
  );
};

CertInProgress.propTypes = {
  application: PropTypes.object,
  application_info: PropTypes.array,
  categoryChoice: PropTypes.number,
  companyId: PropTypes.number,
  getStatus: PropTypes.func,
  goToSinglePage: PropTypes.func,
  goToSinglePage2: PropTypes.any,
  pos: PropTypes.array,
  posLength: PropTypes.number,
  results: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  resultsLength: PropTypes.array,
  status: PropTypes.array,
  testCardStatus: PropTypes.number,
  userType: PropTypes.string
}

export default CertInProgress;